let accessToken: string | null = null;
let accessTokenExp: number | null = null;
let impersonating: boolean = false;
let loggedOut: boolean = false;

export function getToken(): string | null {
  return accessToken;
}

export function getTokenExp(): number | null {
  return accessTokenExp;
}

export function getIsImpersonating(): boolean {
  return impersonating;
}

export function isLoggedOut(): boolean {
  return loggedOut;
}

export function setToken(token: string, exp: number): void {
  accessToken = token;
  accessTokenExp = exp;
  loggedOut = false;
}

export function setImpersonating(value: boolean): void {
  impersonating = value;
}

export function clearTokens(): void {
  accessToken = null;
  accessTokenExp = null;
  impersonating = false;
  loggedOut = true;
}
